import { useEffect } from "react";


const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

const InactivityLogout = ({ children }) => {
  let timer;

useEffect(() => {
  Object.values(events).forEach((item) => {
    window.addEventListener(item, () => {
      resetTimer();// eslint-disable-next-line
      handleTimer();// eslint-disable-next-line
    });
  });// eslint-disable-next-line
}, []);

const resetTimer = () => {
  if (timer) clearTimeout(timer);
};

const handleTimer = () => {
  timer = setTimeout(() => {
    resetTimer();
    Object.values(events).forEach((item) => {
      window.removeEventListener(item, resetTimer);
    });
    logoutAction();
  }, 1800000);
};

const logoutAction = () => {
  localStorage.clear();
  window.location.pathname = "/login";
};
  return children;
};

export default InactivityLogout;